<template>
  <div class="instructions">
    <div class="title" v-on:click="showInstructions = !showInstructions" v-bind:class="showInstructions ? '' : 'closed'">
      <i class="fas fa-info-circle"></i> {{showInstructions ? 'Hide' : 'Show'}} hints &amp; tips
    </div>
    <div class="content" v-if="showInstructions">
      <slot name="content">

      </slot>
    </div>
  </div>

</template>

<script>

  import router from '../../../router'

export default {

    props: ['showhelp'],
    data() {
      return {
        showInstructions: this.showhelp === 'true'
      }
    },
    created() {
      if (this.$route.query.help) {
        this.showInstructions = this.$route.query.help;
      }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  .instructions { }
  .instructions .title { padding: 10px; border: 1px solid #4285f4; border-radius: 4px 4px 0px 0px; border-bottom: 0px; color: #4285f4; cursor: pointer; display: inline-block; background: #FFFFFF; }
  .instructions .closed { border-radius: 4px 4px 4px 4px !important; border-bottom: 1px solid #4285f4; }
  .instructions .content { padding: 10px; border-radius: 4px; background: rgba(255,255,255,1); border: 1px solid #4285f4; border-radius: 0px 4px 4px 4px; line-height:25px;}
</style>



// WEBPACK FOOTER //
// Help.vue?985c9f72